export interface IColors {
  primary: string;
  activeColor: string;
  black: string;
  black07: string;
  black05: string;
  gray: string;
  gray05: string;
  white: string;
  booking: string;
  review: string;
  price: string;
  excellent: string;
  good: string;
  bad: string;
  terrible: string;
  done: string;
  processing: string;
  cancel: string;
  noti: string;
  error: string;
  voucher: string;
  link: string;
  [key: string]: any;
}
export const colors = {
  // suggest global color variables for react native
  primary: "#26bab9",
  price: "#1b959f",
  activeColor: "#1ccfce",
  black: "#000000",
  black01: "#3d3736",
  black07: "#787473",
  black05: "#9e9b9a",
  gray: "#a8a8a8",
  gray05: "#d3d3d3",
  gray02: "#EEEEEE",
  gray01: "#F9F9F9",

  white: "#ffffff",
  booking: "#8eba0b",
  review: "#18bdf4",
  excellent: "#5dbe7c",
  good: "#aacb1f",
  bad: "#ffb31b",
  terrible: "#ff5800",
  done: "#5dbe7c",
  processing: "#ffc95d",
  cancel: "#3d3736",
  noti: "#ff4c4c",
  error: "#ff4c4c",
  voucher: "#fc8b35",
  link: "#14bef4",
  transparent: "transparent",
  avatar: "#0A569C",
};
export default colors;
